import * as React from "react";
import { PlayerCardTemplate } from "../../../../services/bedrock";
import { Button, Form, Input, Label, Modal } from "semantic-ui-react";
import { Controller, useForm } from "react-hook-form";
import { PlayerCardSettingsContext } from "../../Contexts";
import { useContext, useEffect } from "react";

interface AddTemplateModalProps {
  open: boolean;
  templateToDuplicate?: PlayerCardTemplate;
  onClose: (template?: PlayerCardTemplate) => void;
}

const AddTemplateModal: React.FC<AddTemplateModalProps> = ({ open, templateToDuplicate, onClose }) => {
  type NewTemplateValues = {
    name: string;
  };
  const title = templateToDuplicate ? "Duplicate Template" : "Add New Template";
  const methods = useForm<NewTemplateValues>({ defaultValues: { name: "" } });
  const {
    control,
    handleSubmit,
    setValue,
    formState: { isDirty, isSubmitting },
  } = methods;

  const { Templates } = useContext(PlayerCardSettingsContext);

  useEffect(() => {
    if (open) setValue("name", templateToDuplicate ? `${templateToDuplicate.name} (Copy)` : "", { shouldDirty: true });
  }, [open]);

  const cancel = () => onClose();

  const save = handleSubmit(data => {
    if (!isDirty) return;

    return Templates.createTemplate(data.name, templateToDuplicate?.id).then(onClose);
  });

  return (
    <Modal open={open} size="small" className="playerCardAddTemplate">
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <Form>
          {open && (
            <Controller
              name="name"
              control={control}
              rules={{ required: "This is required" }}
              render={({ field, fieldState: { error } }) => {
                return (
                  <Form.Field className="playerCardField playerCardTemplateName" error={!!error}>
                    <div className="playerCardFieldLabel">Name</div>
                    <Input {...field} placeholder="Enter Template Name..." />
                    {error && (
                      <Label basic prompt pointing>
                        {error.message}
                      </Label>
                    )}
                  </Form.Field>
                );
              }}
            />
          )}
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button loading={isSubmitting} secondary content="Cancel" onClick={cancel} />
        <Button loading={isSubmitting} primary disabled={!isDirty} content="Save" onClick={save} />
      </Modal.Actions>
    </Modal>
  );
};
export default AddTemplateModal;
